<div class="close-banner" *ngIf="isVisible && !isHidden">
  <div class="close-banner__icon">
    <i class="pi pi-exclamation-triangle"></i>
  </div>

  <div class="close-banner__body">
    <p class="close-banner__title">{{ suggestion.title }}</p>
    <p class="close-banner__message" *ngIf="suggestion.message">{{ suggestion.message }}</p>
  </div>

  <div class="close-banner__actions">
    <button type="button" class="_outline-danger-btn" [disabled]="isDismissing" (click)="nfiPanel.hide(); keep()">
      <i class="pi pi-spin pi-spinner mr-1" *ngIf="isDismissing"></i>
      Keep as Contact Attempted
    </button>
    <!-- Opens the closing form right under the button, as in the mock-up, instead of a modal over the lead. -->
    <button type="button" class="_danger-btn close-banner__move" [disabled]="isDismissing" (click)="nfiPanel.toggle($event)">
      <span>Move to No Further Interest</span>
      <span class="close-banner__caret"><i class="pi pi-chevron-down"></i></span>
    </button>
  </div>

  <!-- Hides the banner for this visit only; "Keep as Contact Attempted" is what tells Remmi. -->
  <button
    type="button"
    class="close-banner__x"
    aria-label="Hide"
    pTooltip="Hide for now"
    tooltipPosition="left"
    (click)="isHidden = true; nfiPanel.hide()">
    <i class="pi pi-times"></i>
  </button>
</div>

<!-- Not dismissable: the reason dropdown removes the clicked option from the DOM before the click reaches
     the document, so PrimeNG took picking a reason for a click outside and shut the form. It closes from
     its ✕, Cancel, or the button that opened it. -->
<p-overlayPanel
  #nfiPanel
  appendTo="body"
  [dismissable]="false"
  styleClass="close-banner-panel"
  (onShow)="isCloseFormOpen = true"
  (onHide)="isCloseFormOpen = false">
  <ng-template pTemplate="content">
    <app-close-lead-dialog
      [asDialog]="false"
      [visible]="isCloseFormOpen"
      [leadId]="leadId"
      [leadName]="leadName"
      [message]="suggestion?.message"
      [defaultReason]="suggestion?.suggested_reason || 'Uncontactable'"
      (visibleChange)="!$event && nfiPanel.hide()"
      (closed)="nfiPanel.hide(); onLeadClosed()"></app-close-lead-dialog>
  </ng-template>
</p-overlayPanel>
